module.exports = {"152524100":"赛汉塔拉镇","152524101":"朱日和镇","152524102":"乌日根塔拉镇","152524200":"桑宝拉格苏木乡","152524201":"额仁淖尔苏木","152524202":"赛罕乌力吉苏木","152524203":"阿其图乌拉苏木","152524400":"苏尼特右旗朱日和工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152524.json
// module id = 441
// module chunks = 0